module.exports = __webpack_public_path__ + "md.74766d5e912a22cfb39c.svg";


//////////////////
// WEBPACK FOOTER
// C:/xampp/htdocs/sm8-v1-front/src/scss/icons/flag-icon-css/flags/md.svg
// module id = ../../../../../src/scss/icons/flag-icon-css/flags/md.svg
// module chunks = styles